import { useRecoilState, useRecoilValue } from "recoil";
import {
  uploadingFilesState,
  fileUploaderSessionActiveState,
} from "@/store/file-uploader-state";
import { usePolling } from "@/hooks/polling/use-polling";
import { POLLING_INTERVALS } from "@/hooks/polling/polling-intervals";

const useFilesStatusSocketIO = (printHouseId: string | undefined) => {
  const sessionActive = useRecoilValue(fileUploaderSessionActiveState);
  const [, setFiles] = useRecoilState(uploadingFilesState);

  usePolling({
    enabled: !!printHouseId && sessionActive,
    intervalMs: POLLING_INTERVALS.filesStatus,
    pollImmediately: true,
    events: printHouseId
      ? {
          [`updateFileStatus-${printHouseId}`]: (data: any) => {
            setFiles(prev =>
                prev.map((fg) =>
                    fg.filesInfo.some(fileInfo => fileInfo.bucketKey === data.bucketKey)
                        ? {
                          ...fg,
                          filesInfo: fg.filesInfo.map(fileInfo =>
                              fileInfo.bucketKey === data.bucketKey
                                  ? { ...fileInfo, fileStatus: data.status }
                                  : fileInfo
                          ),
                        }
                        : fg
                )
            );
          },
        }
      : {},
  });

  return {
    closeConnection: () => {
      // Session teardown is handled by deactivateFileUploaderSession
    }
  };
};

export { useFilesStatusSocketIO };
